import React, { useEffect, useState } from "react";
import {
  Button,
  IconButton,
  Modal,
  Tooltip ,
  InputLabel,
  CircularProgress,
  Typography,
  Card,
  Grid,
  CardContent,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import {checkForRole} from "../../utils/GetAuth";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetOptimizationParameters, getSalesOffices } from "../../utils/GetAdmin";
import requestMissingContexts, { determineConfig, determineConfigLong, displayConfig } from "../../utils/GetContext";
import TableAbstraction  from "../../componentUtils/TableAbstraction";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import UndoIcon from '@mui/icons-material/Undo';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { saveOptimizationParameters } from "../../utils/PostAdmin";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
    },
    modalInput: {
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
export default function AdminOptimization() {
  const classes = useStyles();
  const [optimizationParameters, SetOptimizationParameters] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'vp_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
  
  const [editedRow, setEditedRow] = React.useState<any|undefined>(undefined);
  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowParamName, setEditedRowParamName] = React.useState<string>("");
  const [editedRowParamValue, setEditedRowParamValue] = React.useState<string>("");
  const [editedRowParamDefault, setEditedRowParamDefault] = React.useState<string>("");

  const handleDelete = () => {
    let oldRec = (editedRow) ? {
      salesOffice: editedRow.salesOffice,
      deliveringPlant: editedRow.deliveringPlant,
      paramName:editedRow.paramName,
      paramValue:editedRow.paramValue,
    } : undefined;
    if(oldRec && oldRec.deliveringPlant !== '*'){
      saveOptimizationParameters(salesOrg,oldRec,undefined).then(ret => {
        if(ret && ret.data){
          SetOptimizationParameters(ret.data.mdOptimizationParam)
          if(ret.data.message){
            alert(ret.data.message);
          }
        }
      });
    }
    setEditedRow(undefined);
  }
  const handleEdit = (tableRow:any) => {
    setCurrent(tableRow);
    setOpenEditWindow(true);
  }
  const setCurrent = (tableRow:any) => {
    setEditedRow(tableRow);
    setEditedRowDeliveringPlant(tableRow.deliveringPlant);
    setEditedRowParamName(tableRow.paramName);
    setEditedRowParamValue(tableRow.paramValue);
    if(tableRow.deliveringPlant !== '*'){
      setEditedRowParamDefault(optimizationParameters.find( p => p.paramName === tableRow.paramName && p.deliveringPlant === '*')?.paramValue || "");
    } else {
      setEditedRowParamDefault("n/a");
    }
  }


  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    setEditedRow(undefined);
    setEditedRowDeliveringPlant("");
    setEditedRowParamName("");
    setEditedRowParamValue("");
    setEditedRowParamDefault("");
  }
  const handleModalSave = () => {
    let oldRec = (editedRow) ? {
      salesOffice: editedRow.deliveringPlant,
      deliveringPlant: editedRow.deliveringPlant,
      paramName:editedRow.paramName,
      paramValue:editedRow.paramValue,
    } : undefined;
    let newRec = {salesOffice: editedRowDeliveringPlant, deliveringPlant: editedRowDeliveringPlant, paramName:editedRowParamName, paramValue:editedRowParamValue};

    if(oldRec && oldRec.deliveringPlant === newRec.deliveringPlant && oldRec.paramName === newRec.paramName)
    { // dont delete if just updating same record
      oldRec = undefined;
    } 
    saveOptimizationParameters(salesOrg,oldRec,newRec).then(ret => {
      if(ret && ret.data){
        SetOptimizationParameters(ret.data.mdOptimizationParam)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });

    handleModalClose();
  } 

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["optimization_param", "SALESOFFICES", "PLANTS"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        GetOptimizationParameters(salesOrg).then((v) => {
          if(v && v.mdOptimizationParam) SetOptimizationParameters(v.mdOptimizationParam);
          
          getSalesOffices(salesOrg)
            .then((v) => {
              setDeliveringPlants(v);
              setDoneLoading(true);
            });
        });
      });
  }, [doneLoading, optimizationParameters, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled ? (
        <TableAbstraction
        settingsKey="ADM_OPT"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Param Override`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setOpenEditWindow(true);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Optimization Parameters"
          columns={[
            {
              label: "Sales Office",
              name: "salesOffice",
              options: {
                filter: true,
                customBodyRender: (value: any) =>{
                  return <div>{(value === '*' ? `${salesOrg} - Default` :`${value} - ${determineConfig(codes, "SALESOFFICES", value)}`)}</div>
                }
              },
            },
            {
              label: "Delivery Plant",
              name: "deliveringPlant",
              options: {
                filter: true,
                customBodyRender: (value: any) =>{
                  return <div>{(value === '*' ? `${salesOrg} - Default` :`${value} - ${determineConfig(codes, "PLANTS", value)}`)}</div>
                }
              },
            },
            {
              label: "Parameter",
              name: "paramName",
              options: {
                filter: true,
                customBodyRender: (value: any) => {
                  return (
                    <Tooltip title={determineConfigLong(codes, "optimization_param", value)}>
                      <div>
                      {`${value} - (${determineConfig(codes, "optimization_param", value)})`}
                      </div>
                    </Tooltip>
                  );
                },
              },
            },
            {
              label: "Value",
              name: "paramValue",
              options: {
                searchable: true,
                filter: false,
              },
            },
            {
              label: "Default",
              name: "dflt",
              options: {
                filter: false,
                renderCell: (param) => {
                  if(param.row.deliveringPlant !== '*')
                  return (
                    optimizationParameters.find( p => p.paramName === param.row.paramName && p.deliveringPlant === '*')?.paramValue || ""
                  );
                },
              },
            },
            {
              label: "Edit",
              name: "edit",
              options: {
                filter: false,
                renderCell: (params) => {
                  if(!!useCompact)
                    return (
                        <React.Fragment>
                          <Tooltip title={"Edit"}>
                            <EditIcon fontSize="small" onClick={() => {handleEdit(params.row)}}/>
                          </Tooltip>
                          {(params.value !== '*') ?( 
                          <Tooltip title={"Reset to default"}>
                            <UndoIcon fontSize="small" onClick={() => {setCurrent(params.row); setConfirmDelete(true);}}/>
                          </Tooltip>) : (<div></div>)}
                        </React.Fragment>
                      );
                    else
                      return (
                          <React.Fragment>
                            <Tooltip title={"Edit"}>
                              <IconButton onClick={() => {handleEdit(params.row)}}>
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            {(params.value !== '*') ?( 
                              <Tooltip title={"Reset to default"}>
                                <IconButton onClick={() => {setCurrent(params.row); setConfirmDelete(true);}}>
                                  <UndoIcon />
                                </IconButton>
                              </Tooltip>) : (<div></div>)}
                          </React.Fragment>
                        );
                }
              },
            },
          ]}
          data={optimizationParameters}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      <Modal
          open={openEditWindow}
          onClose={handleModalClose}
      >
        <div style={modalStyle} className={classes.paper} >
          <Typography variant="h4" className={classes.modalTitle} paragraph>Optimization Parameter</Typography>
          <Grid container spacing={2} className={classes.modalGrid}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" className={classes.modalText} paragraph dangerouslySetInnerHTML={{ __html: determineConfigLong(codes, "optimization_param", editedRowParamName)}} >
              </Typography>
              <Card className={classes.modalCard}>
                <CardContent>
                <Grid container spacing={1} className={classes.modalGrid}>
                  <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                    <InputLabel >Delivery Plant</InputLabel>
                    <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant} disabled={editedRowDeliveringPlant === '*'}
                        inputProps={{name: 'Delivery Plant',}}
                        className={classes.modalInput}
                        onChange={(e) => { 
                            setEditedRowDeliveringPlant((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                            }}>
                        {editedRowDeliveringPlant === '*' ? 
                            (<MenuItem key='*' value='*'>{`${salesOrg} - Default`}</MenuItem>)
                            :
                            ((deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                              <MenuItem key={so[1].code} value={so[1].code}>
                                {so[1].code + " - " + so[1].text}
                              </MenuItem>
                              ))):(<div></div>))}
                    </Select>
                  </Grid>
                  <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                    <InputLabel >Param Name</InputLabel>
                    <Select label="Param Name" required placeholder='Param Name' value={editedRowParamName} disabled={editedRowDeliveringPlant === '*'}
                        inputProps={{name: 'Delivery Plant',}}
                        className={classes.modalInput}
                        onChange={(e) => { 
                          let nVal = (e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "";
                            setEditedRowParamName(nVal); 
                            setEditedRowParamDefault(optimizationParameters.find( p => p.paramName === nVal && p.deliveringPlant === '*')?.paramValue || "");
                            }}>
                        {editedRowDeliveringPlant === '*' ? 
                            (<MenuItem key={editedRowParamName} value={editedRowParamName}>{editedRowParamName}</MenuItem>)
                            :
                            (
                              displayConfig(codes,'optimization_param').map( prams => (
                                <MenuItem key={prams.code} value={prams.code}>
                                 {prams.code}
                                </MenuItem>
                              ))
                              )}
                    </Select>
                  </Grid>
                  <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                    <InputLabel >Value</InputLabel>
                    <TextField placeholder='Value' type='text'
                        className={classes.modalInput}
                        value={editedRowParamValue}
                        onChange={(e) => { 
                          setEditedRowParamValue((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                        }}></TextField>
                    </Grid>
                    {editedRowDeliveringPlant === '*' ? (<div></div>) :(
                      <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
                        <InputLabel >Default Value</InputLabel>
                        <TextField placeholder='Default' type='text' disabled={true}
                            className={classes.modalInput}
                            value={editedRowParamDefault}
                            ></TextField>
                      </Grid>
                    )}
                  </Grid>
                  </CardContent>
                </Card>
                <div style={{ paddingRight: "5px", textAlign:"right"}}>
                      <React.Fragment>
                          <Tooltip title={"Save"}>
                              <IconButton onClick={handleModalSave}>
                                  <SaveIcon />
                              </IconButton>
                          </Tooltip>
                          <Tooltip title={"Cancel"}>
                              <IconButton onClick={handleModalClose}>
                                  <Clear />
                              </IconButton>
                          </Tooltip>
                      </React.Fragment>
                    </div>
              </Grid>
            </Grid>
        </div>
      </Modal>
      
      <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to reset {editedRowDeliveringPlant} override for {editedRowParamName} to the default value "{editedRowParamDefault}"?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{setEditedRow(undefined); setConfirmDelete(false);}} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
}